import { render, staticRenderFns } from "./pagination-record.vue?vue&type=template&id=62d39b41&"
import script from "./pagination-record.vue?vue&type=script&lang=js&"
export * from "./pagination-record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports